import { render, staticRenderFns } from "./Header2.vue?vue&type=template&id=c748ff1a&scoped=true&"
import script from "./Header2.vue?vue&type=script&lang=js&"
export * from "./Header2.vue?vue&type=script&lang=js&"
import style0 from "./Header2.vue?vue&type=style&index=0&id=c748ff1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c748ff1a",
  null
  
)

export default component.exports